// hooks/useAtualizarDados.ts
import { useState } from "react";
import { atualizarIndicacoesParceiros } from "../../../services/atualizarIndicacoesParceirosService";
// --------------------- Import Services ---------------------

export const useAtualizarIndicacoesParceiros = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const atualizar = async (indicacaoData: any) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const atualizarDados = await atualizarIndicacoesParceiros(indicacaoData);
      if (atualizarDados) {
        setSuccess(true);
      } else {
        setError(true);
      }
      return atualizarDados;
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    atualizar,
    isLoading,
    isSuccess,
    error,
    success,
    resetError,
    resetSuccess,
  };
};
